module.exports = __webpack_public_path__ + "img/haijunlan3.19258dae.png";